import { color, Link, typography } from '@gyym/ui'
import styled from 'styled-components'

export const Container = styled(Link)`
  border: 1px solid ${color('blue.01')};
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  max-width: 290px;
  height: 73px;
  border-radius: 5px;
  background-color: ${color('white')};
  box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.23);
  text-decoration: none;

  & > img {
    margin-left: 35px !important;
  }
`

export const Text = styled.div`
  ${typography('caption1')};
  color: ${color('blue.01')};
  margin-left: 20px;
  margin-bottom: 16px;
`
